module.exports = __webpack_public_path__ + "img/aParty_111223_A.d0ed9149.jpg";